export default __webpack_public_path__ + "static/media/IMG_2195.258901ee.jpg";